import { socket } from "../../socket";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import getDate from "../../helpers/getDate";

import Hint from "../../components/Hint/Hint";
import { Icon } from "../../components/Icon";

const mockData = [
  {
    text: 'Test',
    isRead: 0,
    type: 2,
    nickname: 'Romanus',
    date: '2025-02-20T09:24:59.000Z',
  },
  {
    text: 'Test',
    isRead: 1,
    type: 3,
    nickname: 'Udaff',
    date: '2025-02-20T07:24:59.000Z',
  }
]

const SystemNotificationsPage = () => {
  const hint = useSelector( state => state.hints)
  const navigate = useNavigate();

  const onNotificationClick = (el) => {
    if (el.type === 2 || el.type === 1 || el.type === 5) {
        navigate('/room/'+el.roomId);
    }
    else if (el.type === 3) {
        navigate('/supportRoom/'+el.roomId);
    }
    else if (el.type === 4) {
        navigate('/profile/settings/'+el.userId);
    }

    socket.emit('privateMessageRead', {id: el.id});
  }

  return (
    <div className="profileSection gamesPage" style={{marginBottom:'0px'}}>
      <div className="prFlexRow profileSectionHeader" style={{marginBottom:'40px'}}>
          <h2 >Чорний список
            <div className="infoHelp"> <Hint align='left' item={hint[36]}/></div>
          </h2>
      </div>

      <div className="roomList">
        {mockData.length > 0 && mockData.map((el, index) => {
          return (
            <div
              key={index}
              className={`roomItem requestItem prFlexRow systemNotification ${el.isRead === 1 ? 'notificationRead': ''}`}
              style={{ flexWrap: 'nowrap', gap: '10px' }}
            >
              <div className="roomItemBlock" style={{ minWidth: 'fit-content', borderLeft: 'none' }}>
                <div className="roomItemBlockHeader" style={{ fontSize: '14px' }}>
                  Нове повідомлення
                </div>
              </div>
              <div
                className="roomItemBlock pointer"
                style={{ width: '100%' }}
                onClick={() => onNotificationClick(el)}
              >
                  <div className='notificationItemHeader' style={{ fontSize: '14px' }}>
                    {el.type===0 && 'Запит адміністратора: '}
                    {el.type===1 && 'Запит арбітра: '}
                    {el.type===2 && `Вас запрошено в гру ${el.description}: `}
                    {el.type===3 && `Нове повідомлення в підтримці `}
                    {el.type===4 && `Нове звернення на верифікацію `}
                    {el.type===5 && `Кімната закрита`}
                    <span>{el.nickname}</span>
                  </div>
              </div>
              <div className="roomItemBlock" style={{ minWidth: 'fit-content' }}>
                <div className="roomItemBlockHeader">
                  Час створення повідомлення
                </div>
                <div className="prFlexRow dateTimeBlock" style={{ gap: '18px' }}>
                  <div className="roomItemBlockValue"><Icon type='time'></Icon>{getDate(el.date.replace('T',' '),'hh:mm',":")}</div>
                  <div className="roomItemBlockValue"><Icon type='calendar'></Icon>{getDate(el.date.replace('T',' '),'dd/mm/yyyy',".")}</div>
                </div>
              </div>
            </div>
          )
        }) 
        }
      </div>
    </div>
  )
}

export default SystemNotificationsPage;